/**
 * Where the Chrome recorder is installed from.
 *
 * One constant, because the answer is needed in two bundles that share nothing
 * else: the marketing site offers it to somebody deciding, and the application
 * offers it to somebody who has already decided and pressed record. Written in
 * one place so a listing that moves is one edit rather than a search.
 *
 * Listed on 2026-09-28. Until then every one of those surfaces said "coming
 * soon" and offered nothing to press — which was the honest answer while there
 * was nowhere to send anybody, and is now simply out of date.
 *
 * The id is the store's, assigned at publication and stable for the life of
 * the listing. It is not the extension's key and not a secret.
 */
export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/veyso-recorder/fpedcakdckodckmemhbmakebjlbojdig";

/** The name the listing carries, for a link that says where it goes. */
export const CHROME_STORE_NAME = "Veyso Recorder";
